import UserGroupWorkpositionTreeContainer from '@src/components/usergroup/update/UserGroupWorkpositionTreeContainer';
import React from 'react';
import { withRouter, WithRouterProps } from 'react-router';

const CourseUserGroupTreePage = (props: WithRouterProps) => <UserGroupWorkpositionTreeContainer courseId={props.params.courseId} />;

export default withRouter(CourseUserGroupTreePage);
